'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$11() {
  this.bbH = null;
  this.bbI = false;
}
export { $c_Lpresto_Presto$$anon$11 as $c_Lpresto_Presto$$anon$11 };
$p = $c_Lpresto_Presto$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$11;
/** @constructor */
function $h_Lpresto_Presto$$anon$11() {
}
export { $h_Lpresto_Presto$$anon$11 as $h_Lpresto_Presto$$anon$11 };
$h_Lpresto_Presto$$anon$11.prototype = $p;
$p.P = (function() {
  if ((!this.bbI)) {
    this.bbH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aE()));
    this.bbI = true;
  }
  return this.bbH;
});
var $d_Lpresto_Presto$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$11, "presto.Presto$$anon$11", ({
  Nf: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_Presto$$anon$11 as $d_Lpresto_Presto$$anon$11 };
//# sourceMappingURL=presto.-Presto$$anon$11.js.map
